import styled from 'styled-components'

import { media } from 'styles/media'

// import ShowMoreText from '../../ShowMoreText'
import LazyImage from '../../../components/display/LazyImage'
import Avatar from '../../../components/display/Avatar'

import type { Member } from './types'

const Wrapper = styled.div`
  text-align: center;

  ${Avatar} {
    display: inline-block;
    width: 100px;
    height: 100px;
    margin: 0;
    margin-bottom: 8px;

    ${media.md`
      width: 140px;
      height: 140px;
    `}
  }
`

// const Content = styled.div`
// `

const Name = styled.h5`
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.3;
  margin-bottom: 8px;

  ${media.md`
    line-height: 1.4;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-lg']?.['font-size']?.value};
  `}
`

const Position = styled.h6`
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  font-weight: 300;
  line-height: 1.375;
  margin-bottom: 16px;

  line-height: 1.4;

  ${media.md`
    line-height: 1.3;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-sm']?.['font-size']?.value};
  `}
`

export default ({ image, name, position }: Member) => (
  <Wrapper>
    <Avatar>
      <LazyImage data-src={image} alt={name} preload />
    </Avatar>

    <Name>{name}</Name>
    <Position>{position}</Position>

    {/* <Content>
      <ShowMoreText lines={3} inline>
        {bio}
      </ShowMoreText>
    </Content> */}
  </Wrapper>
)
